module.exports = __webpack_public_path__ + "static/media/chair.35e335ea.png";